import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=53824f39&scoped=true&"
import script from "./Downloads.vue?vue&type=script&lang=js&"
export * from "./Downloads.vue?vue&type=script&lang=js&"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=53824f39&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53824f39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
